import { render, staticRenderFns } from "./onLineLive.vue?vue&type=template&id=157c19e0&scoped=true&"
import script from "./onLineLive.vue?vue&type=script&lang=js&"
export * from "./onLineLive.vue?vue&type=script&lang=js&"
import style0 from "./onLineLive.vue?vue&type=style&index=0&id=157c19e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157c19e0",
  null
  
)

export default component.exports